var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FIN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.2064,7.9244 C1.2064,11.6798 4.2508,14.7242 8.0062,14.7242 C11.7616,14.7242 14.8062,11.6798 14.8062,7.9244 C14.8062,4.1688 11.7616,1.1242 8.0062,1.1242 C4.2508,1.1242 1.2064,4.1688 1.2064,7.9244 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FICC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disclaimer---language-options",
    transform: "translate(-494.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lang",
    transform: "translate(448.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FIN",
    transform: "translate(46.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4184 12.4184,16 8,16 C3.5818,16 0,12.4184 0,8 C0,3.5818 3.5818,0 8,0 C12.4184,0 16,3.5818 16,8",
    id: "Fill-1192-Copy",
    fill: "#336581"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-1195"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1194",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.2274 14.7242 5.5726 14.7242 5.5726 9.3242 -2.2274 9.3242"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1196",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.2274 6.5244 5.5726 6.5244 5.5726 1.1244 -2.2274 1.1244"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1197",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "8.3726 14.7242 21.1804 14.7242 21.1804 9.3242 8.3726 9.3242"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1198",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "8.3726 6.5244 21.1804 6.5244 21.1804 1.1244 8.3726 1.1244"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1199",
    fill: "#2007FF",
    mask: "url(#mask-2)",
    points: "5.5726 16.2342 8.3726 16.2342 8.3726 1.1242 5.5726 1.1242"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1200",
    fill: "#2007FF",
    mask: "url(#mask-2)",
    points: "-2.4274 9.3244 23.4768 9.3244 23.4768 6.5244 -2.4274 6.5244"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFin);
export default __webpack_public_path__ + "static/media/FIN.0934f94d16f04f208d4516c5bca144d1.svg";
export { ForwardRef as ReactComponent };